import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type ModerateClubRatingRequest = {
  clubRatingId: number;
  comment?: string; // optional
  reply?: string; // optional
};

export type ModerateClubRatingParams = RequestConfig<ModerateClubRatingRequest>;

// Функция для модерации рейтинга (редактирование комментария и/или ответа клуба)
export const moderateClubRating = async ({
  params,
  config
}: ModerateClubRatingParams) =>
  api.put(
    `/api/ratings/moderate/${params.clubRatingId}`,
    { comment: params.comment, reply: params.reply },
    { ...config }
  );
